<pos-menu></pos-menu>
<ion-router-outlet id="main"></ion-router-outlet>
<notify-popups></notify-popups>
